(function ($, Drupal, drupalSettings) {
  'use strict';

  Drupal.behaviors.befActiveFilters = {
    attach: function (context, settings) {
      var $form = $('#views-exposed-form-clinic-finder-page-1', context);

      // var treatments = $('select[name="field_treatments_target_id_1[]"]');
      //
      // if (treatments.val() && treatments.val().length >= 2 && $('.form-item--field-treatments-target-id-1').width() > 300) {
      //   $('#views-exposed-form-clinic-finder-page-1').find('.claro-details__wrapper').addClass('one_column');
      // } else {
      //   $('#views-exposed-form-clinic-finder-page-1').find('.one_column').removeClass('one_column');
      // }

      if ($form.length === 0) return;

      if ($('#active-filters-container').length === 0) {
        $form.after('<div id="active-filters-container" class="active-filters-wrapper"><strong>Filtros ativos:</strong> <div class="active-filters-tags"></div></div>');
      }

      var $container = $('.active-filters-tags');
      var $clearAll = $('<button type="button" class="clear-all-filters">Limpar tudo</button>');

      function triggerViewRefresh() {
        var $form = $('#views-exposed-form-clinic-finder-page-1');
        var $submitButton = $form.find('.form-submit').first();

        var ajaxId = $submitButton.attr('id');
        if (Drupal.ajax && Drupal.ajax.instances[ajaxId]) {
          Drupal.ajax.instances[ajaxId].eventResponse($submitButton[0], 'click');
        } else {
          $submitButton.click();
        }
      }

      function updateActiveFilters() {
        $container.empty();
        var hasFilters = false;

        var productNames = $('select[name="field_product_name_target_id[]"]').val();
        if (productNames && productNames.length > 0) {
          productNames.forEach(function(val) {
            var text = $('select[name="field_product_name_target_id[]"] option[value="' + val + '"]').text();
            var $tag = $('<span class="filter-tag" data-field="product" data-value="' + val + '">' + text + ' <button type="button" class="remove-filter">×</button></span>');
            $container.append($tag);
            hasFilters = true;
          });
        }

        var specialties = $('select[name="field_hcp_specialty_target_id[]"]').val();
        if (specialties && specialties.length > 0) {
          specialties.forEach(function(val) {
            var text = $('select[name="field_hcp_specialty_target_id[]"] option[value="' + val + '"]').text();
            var $tag = $('<span class="filter-tag" data-field="specialty" data-value="' + val + '">' + text + ' <button type="button" class="remove-filter">×</button></span>');
            $container.append($tag);
            hasFilters = true;
          });
        }

        // Languages
        var languages = $('select[name="field_spoken_languages_target_id[]"]').val();
        if (languages && languages.length > 0) {
          languages.forEach(function(val) {
            var text = $('select[name="field_spoken_languages_target_id[]"] option[value="' + val + '"]').text();
            var $tag = $('<span class="filter-tag" data-field="language" data-value="' + val + '">' + text + ' <button type="button" class="remove-filter">×</button></span>');
            $container.append($tag);
            hasFilters = true;
          });
        }

        // var booking = $('select[name="field_booking_availability_target_id[]"]').val();
        // if (booking && booking.length > 0) {
        //   booking.forEach(function(val) {
        //     var text = $('select[name="field_booking_availability_target_id[]"] option[value="' + val + '"]').text();
        //     var $tag = $('<span class="filter-tag" data-field="booking" data-value="' + val + '">' + text + ' <button type="button" class="remove-filter">×</button></span>');
        //     $container.append($tag);
        //     hasFilters = true;
        //   });
        // }

        if (hasFilters) {
          $container.append($clearAll);
          $('#active-filters-container').show();
        } else {
          $('#active-filters-container').hide();
        }

      }

      $form.find('.bef--secondary select, .bef--secondary input[type="checkbox"]').on('change', function() {
        updateActiveFilters();
        triggerViewRefresh();
      });

      $container.on('click', '.remove-filter', function() {
        var $tag = $(this).closest('.filter-tag');
        var field = $tag.data('field');
        var value = $tag.data('value');

        var fieldMap = {
          'product': 'select[name="field_product_name_target_id[]"]',
          'specialty': 'select[name="field_hcp_specialty_target_id[]"]',
          'language': 'select[name="field_spoken_languages_target_id[]"]',
          // 'booking': 'select[name="field_booking_availability_target_id[]"]'
        };

        var $select = $(fieldMap[field]);
        var currentVal = $select.val() || [];
        var newVal = currentVal.filter(function(v) { return v != value; });

        $select.val(newVal).trigger('change');
        triggerViewRefresh();
      });

      $container.on('click', '.clear-all-filters', function(e) {
        e.preventDefault();

        $form.find('.bef--secondary select, .bef--secondary input').val([]).trigger('change');

      });

      updateActiveFilters();

      $form.find('.form-actions .form-submit').on('click', function() {
        if (
            $(window).width() >= 1024 &&
            drupalSettings.bef?.openSecondary
        ) {
          $('.bef-exposed-form form .bef--secondary').attr('open', true);
        }
      })
    }
  };

})(jQuery, Drupal, drupalSettings);
